"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Card } from "@/components/ui/card";
import { FileText, ShieldCheck, Scale } from "lucide-react";
export default function TermsHeader() {
  return <section id="termsheader" data-nav="light" className="relative overflow-hidden bg-background text-foreground pt-32 pb-16 lg:pt-36 lg:pb-20 border-b border-border/60">
      {/* Decorative 4D Isometric Glass Planes & Ambient Accents */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        {/* Subtle grid pattern */}
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] opacity-25" />

        {/* Ambient warm glow */}
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[36rem] h-72 bg-chart-1/10 rounded-full blur-3xl" />

        {/* Floating isometric glass accent plane (right) */}
        <div className="hidden lg:block absolute -right-12 top-12 w-64 h-48 rounded-2xl bg-card/60 border border-border/80 shadow-lg backdrop-blur-md transform rotate-6 skew-y-3 opacity-60" />
        {/* Floating isometric glass accent plane (left) */}
        <div className="hidden lg:block absolute -left-10 top-28 w-56 h-40 rounded-2xl bg-card/40 border border-border/60 shadow-md backdrop-blur-sm transform -rotate-6 -skew-y-2 opacity-50" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs Row */}
        <div className="mb-8 flex items-center">
          <Breadcrumb className="px-3 py-1.5 rounded-md bg-card/80 border border-border/80 shadow-2xs backdrop-blur-sm inline-flex">
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/" className="text-muted-foreground hover:text-foreground transition-colors font-medium">
                    Home
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <span className="text-muted-foreground font-medium">Legal</span>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-semibold text-foreground">
                  Terms
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {/* Header Glass Surface Card */}
        <Card className="relative overflow-hidden border border-border/80 bg-card/90 backdrop-blur-md shadow-md rounded-xl p-8 sm:p-12">
          {/* Subtle copper accent highlight border */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-chart-1 via-chart-1/60 to-transparent" aria-hidden="true" />

          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 text-chart-1 text-sm font-semibold tracking-wide">
              <Scale className="size-4" aria-hidden="true" />
              <span>Agreement & Guidelines</span>
            </div>

            <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
              Terms of Service
            </h1>

            <p className="text-muted-foreground text-base sm:text-lg leading-relaxed pt-1">
              Please review the terms and conditions governing residential remodeling,
              design-build consultations, contract agreements, and warranty provisions
              with Decatur Heritage Renovations.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}